/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка
 */
export interface ErrorInfo {
  /** Код ошибки */
  errorCode?: "OK" | "ERROR";

  /** Описание ошибки */
  errorDesc?: string;
}

export interface ErrorResponse {
  /** Список ошибок */
  errorList?: ErrorInfo[];
}

/**
 * Информация о файле
 */
export interface BillUploadResponse {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Идентификатор клиента */
  clientId?: string;

  /**
   * Идентификатор файла в файловом хранилище
   * @format uuid
   */
  extId?: string;

  /** Состояние заливки файла */
  ready?: boolean;

  /** Наименование файла */
  filename?: string;

  /**
   * Размер файла
   * @format int64
   */
  fileSize?: number;

  /** Хэш */
  hash?: string;

  /**
   * Дата создания записи
   * @format date-time
   */
  created?: string;
}

export interface BillState {
  /**
   * Идентификатор реестра начислений
   * @format uuid
   */
  id?: string;

  /** Тип документа */
  type?: "BILLSREGISTER";

  /** Номер документа */
  number?: string;

  /** Код статуса документа */
  state?: string;
}

export interface BillsCcb {
  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ ККБ */
  document?: CcbDocumentEsppCcbFields;
  orderCcb?: string;
}

/**
 * Документ ККБ
 */
export interface CcbDocumentEsppCcbFields {
  /** Тип документа */
  type?: DocType;

  /** Набор полей реестра начислений */
  fields?: EsppCcbFields;
}

/**
 * Тип документа
 */
export interface DocType {
  /**
   * Наименование документа
   * @example billsregister
   */
  name?: string;

  /**
   * Описание документа
   * @example Реестр начислений
   */
  desc?: string;
}

/**
 * Набор полей реестра начислений
 */
export interface EsppCcbFields {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор файла
   * @format uuid
   */
  extId?: string;

  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /**
   * Дата и время загрузки файла
   * @format date-time
   */
  createDate?: string;

  /** Хэш-сумма файла */
  hash?: string;
}

export interface ConfirmTypeResponse {
  confirmType?: string;
}

export interface BillUploadState {
  /** @format uuid */
  fileId?: string;
  state?: "IN_PROCESS" | "LOADED" | "ERROR";
  error?: string;
}

export interface ShortCertInfo {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Владелец сертификата. */
  owner: string;

  /**
   * Дата и время начала действия сертификата.
   * @format date-time
   */
  notBefore: string;

  /**
   * Дата и время окончания действия сертификата.
   * @format date-time
   */
  notAfter: string;

  /** Статус сертификата. */
  state: string;

  /**
   * Время установки статуса.
   * @format date-time
   */
  stateTime: string;

  /** Тело сертификата в PEM-формате. */
  data: string;

  /**
   * Дата и время окончания действия приватного ключа.
   * @format date-time
   */
  timePk?: string;

  /** ИНН организации, сотрудником которой является владелец сертификата (10 цифр), или ИНН физического лица владельца сертификата, являющегося индивидуальным предпринимателем (12 цифр).  */
  inn?: string;

  /** Для ЮЛ или ИП краткое название ЮЛ или ИП – владельца СКПЭП в соответствии с ЕГРЮЛ или ЕГРИП. */
  organization?: string;

  /** Должность владельца СКПЭП для ЮЛ, "Индивидуальный предприниматель" - для ИП. */
  position?: string;
}

/**
 * Отображение для реестра файлов
 */
export interface OperationFileView {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Дата-время загрузки
   * @format date-time
   */
  created?: string;

  /** Вид реестра */
  type?: "PAYMENT_REGISTRY" | "BILL_REGISTRY";

  /**
   * Идентификатор файла
   * @format uuid
   */
  fileId?: string;

  /** Имя файла */
  filename?: string;

  /** Статус файла */
  status?:
    | "CLIENT_UPLOADED"
    | "BANK_DOWNLOAD"
    | "REMOVED"
    | "BANK_UPLOAD"
    | "CLIENT_DOWNLOAD"
    | "SENT"
    | "PREPARED"
    | "PARTIALLY_SIGNED"
    | "SIGNED";

  /**
   * Дата время обновления статуса
   * @format date-time
   */
  statusDateTime?: string;

  /** Текстовое представление для поля type */
  typeTitle?: string;

  /** Текстовое представление для поля status */
  statusTitle?: string;
}

export interface PagedResultOperationFileView {
  content?: OperationFileView[];

  /** @format int32 */
  totalRecord?: number;
}

/**
 * Отчет Эксроу
 */
export interface Escrow {
  /**
   * ИД отчета
   * @format uuid
   */
  id?: string;

  /** Наименование файла с отчетом */
  name?: string;

  /**
   * Размер файла с отчетом
   * @format int32
   */
  fileSize?: number;

  /**
   * Дата и время получения отчета от ЦФТ
   * @format date-time
   */
  createDate?: string;

  /** Признак готовности */
  isReady?: boolean;
}

/**
 * Ответ с отчетами по счетам Эскроу
 */
export interface EscrowBlock {
  /** Наличие других записей */
  hasMore?: boolean;

  /**
   * Количество записей
   * @format int32
   */
  size?: number;
  data?: Escrow[];
  permissions?: Permission[];
}

/**
 * Полномочие
 */
export interface Permission {
  /** Наименование полномочия */
  name?: string;

  /** Описание полномочия */
  desc?: string;

  /** Наличие полномочия */
  isAvailable?: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-cash-management
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-cash-management.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/display/ndbouldev/CashManagement)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Метод загрузки файла начислений
     *
     * @tags Bills
     * @name Upload
     * @summary Запрос для загрузки файла начислений
     * @request POST:/api/cashman/external/v1/register/bills/upload
     * @secure
     */
    upload: (data: { file: File }, params: RequestParams = {}) =>
      this.request<BillUploadResponse, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод обновления статуса после процедуры подписания
     *
     * @tags Bills
     * @name UpdateStatus
     * @summary Запрос обновления статуса после процедуры подписания
     * @request POST:/api/cashman/external/v1/register/bills/update-status/{documentType}/{documentId}
     * @secure
     */
    updateStatus: (
      documentType: "BILLSREGISTER",
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<BillState, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/update-status/${documentType}/${documentId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод для отправки подписанного документа в банк
     *
     * @tags Bills
     * @name SendBills
     * @summary Запрос для отправки подписанного документа в банк
     * @request POST:/api/cashman/external/v1/register/bills/send/{documentType}/{documentId}
     * @secure
     */
    sendBills: (
      documentType: "BILLSREGISTER",
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<BillState, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/send/${documentType}/${documentId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод скачивания файла реестра платежей
     *
     * @tags Payments
     * @name Download
     * @summary Запрос на скачивание файла реестра платежей
     * @request GET:/api/cashman/external/v1/register/payments/{id}/download
     * @secure
     */
    download: (id: string, params: RequestParams = {}) =>
      this.request<File, ErrorResponse>({
        path: `/api/cashman/external/v1/register/payments/${id}/download`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Метод получения ККБ реестра начислений
     *
     * @tags Bills
     * @name OrderCcb
     * @summary Запрос на получение ККБ реестра начислений
     * @request GET:/api/cashman/external/v1/register/bills/order-ccb/{documentType}/{documentId}
     * @secure
     */
    orderCcb: (
      documentType: "BILLSREGISTER",
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<BillsCcb, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/order-ccb/${documentType}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения типа подтверждения
     *
     * @tags Bills
     * @name GetConfirmType
     * @summary Запрос на получение типа подтверждения
     * @request GET:/api/cashman/external/v1/register/bills/confirmation/confirm-type
     * @secure
     */
    getConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверка, сохранился ли файл в файловое хранилище
     *
     * @tags Bills
     * @name CheckFileUploadState
     * @summary Запрос проверки состояния файла (сохранился или нет в файловое хранилище)
     * @request GET:/api/cashman/external/v1/register/bills/check-file-uploaded-state/{id}
     * @secure
     */
    checkFileUploadState: (id: string, params: RequestParams = {}) =>
      this.request<BillUploadState, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/check-file-uploaded-state/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения актуальных сертификатов пользователя
     *
     * @tags Bills
     * @name GetActualCertificates
     * @summary Запрос на получения актуальных сертификатов пользователя
     * @request GET:/api/cashman/external/v1/register/bills/certificate/client-active-certificate
     * @secure
     */
    getActualCertificates: (params: RequestParams = {}) =>
      this.request<ShortCertInfo[], ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Метод получения списка файлов начислений и платежей
     *
     * @tags Bills-Payments
     * @name Find
     * @summary Запрос на получение списка файлов начислений и платежей
     * @request GET:/api/cashman/external/v1/register/bills-payments/find
     * @secure
     */
    find: (
      query?: { page?: string; size?: string },
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOperationFileView, ErrorResponse>({
        path: `/api/cashman/external/v1/register/bills-payments/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчеты по счетам Эскроу
     * @name GetEscrowReports
     * @summary Получение списка отчетов по счетам Эскроу
     * @request GET:/api/cashman/external/v1/escrow/report
     * @secure
     */
    getEscrowReports: (
      query: {
        size: number;
        position: number;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<EscrowBlock, ErrorInfo>({
        path: `/api/cashman/external/v1/escrow/report`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчеты по счетам Эскроу
     * @name GetEscrowReportFile
     * @summary Получение файла отчета Эскроу из FileApi
     * @request GET:/api/cashman/external/v1/escrow/report/print
     * @secure
     */
    getEscrowReportFile: (query: { id: string }, params: RequestParams = {}) =>
      this.request<File, ErrorInfo>({
        path: `/api/cashman/external/v1/escrow/report/print`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
}

export const api = new Api();
